export const rouge = "#001529";
export const bleuclair = "#40a9ff";
export const bleufonce = "#0540F2";
export const jaune = "#F2E205";
export const vert = "#02732A";
export const gris = "#A6ABAB";
